var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminCurriculumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13H0.666667C0.489856 13 0.320286 12.9315 0.195262 12.8096C0.0702379 12.6877 0 12.5224 0 12.35V0.65C0 0.477609 0.0702379 0.312279 0.195262 0.190381C0.320286 0.0684819 0.489856 0 0.666667 0H11.3333C11.5101 0 11.6797 0.0684819 11.8047 0.190381C11.9298 0.312279 12 0.477609 12 0.65V12.35C12 12.5224 11.9298 12.6877 11.8047 12.8096C11.6797 12.9315 11.5101 13 11.3333 13ZM10.6667 11.7V1.3H1.33333V11.7H10.6667ZM3.33333 3.25H8.66667V4.55H3.33333V3.25ZM3.33333 5.85H8.66667V7.15H3.33333V5.85ZM3.33333 8.45H6.66667V9.75H3.33333V8.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCurriculumIcon);
export default __webpack_public_path__ + "static/media/AdminCurriculumIcon.7fd4d226fa88eaac7e62cd829cd5d266.svg";
export { ForwardRef as ReactComponent };